import styled from "styled-components";

export const Header3 = styled.h3`
  font-size: 6.4rem;
  font-weight: 650;

  @media (max-width: 900px) {
    font-size: 3.6rem;
    font-weight: 600;
    text-align: center;
  }
`;

export const Paragraph = styled.p`
  font-size: 2.4rem;
  font-weight: 400;
  line-height: 1.4;

  @media (max-width: 900px) {
    font-size: 2.2rem;
  }
`;
